import { useEffect } from 'react';
import { tablesActions, tablesSelectors } from '../../../actions';
import { RootState, useAppDispatch, useAppSelector } from '../../base-redux';
import { formatTableFormFromState } from '../table.utils';
import { IFilterOption, ITableToggle } from '../table.interfaces';
import { useTheme } from '../../base-components';
import { getBasicColorsObject } from '../../../common/utils/base.utils';

export const useTableData = (
    tableId: string,
    filters: Array<IFilterOption>,
    toggleConfig?: Array<ITableToggle>
) => {
    const dispatch = useAppDispatch();
    const theme = useTheme();
    const baseColors = getBasicColorsObject(theme.palette);

    // Select tableState and tableData from the Redux store
    const tableState = useAppSelector((state: RootState) =>
        tablesSelectors.getTablesState(state, tableId)
    );
    const rowsData = useAppSelector((state: RootState) =>
        tablesSelectors.getRowsData(state, tableId)
    );

    useEffect(() => {
        if (tableState.initialLoad && tableId) {
            dispatch(
                tablesActions.fetchTableDataById({
                    tableId,
                    formData: formatTableFormFromState(tableState, filters, toggleConfig),
                    page: 1,
                    baseColors,
                })
            );
            const updatedTableState = {
                ...tableState,
                initialLoad: false,
            };
            dispatch(
                tablesActions.setTableStateById({
                    tableId,
                    tableState: updatedTableState,
                })
            );
        }
    }, [dispatch, tableId, tableState]);

    return { tableState, rowsData };
};
